import { Inject } from '@angular/core';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SystemDataService } from '../../services/systemdata.service';

@Component({
  selector: 'app-maintainance',
  templateUrl: './maintainance.component.html',
  styleUrls: ['./maintainance.component.scss']
})
export class MaintainanceComponent implements OnInit {
  @Output() closeDialogue = new EventEmitter();
  maintainanceActivity : any = [];
  constructor(@Inject(MAT_DIALOG_DATA)
  public data  = {
    MaintenanceMessage: ''
  },
  public dialog: MatDialog,
  public sysService : SystemDataService,
  public dialogRef: MatDialogRef<MaintainanceComponent>) { }

  ngOnInit() {
    this.checkMaintainance();
  }
  checkMaintainance(){
    this.sysService.maintainancecheck().subscribe(
      res=> this.checkMaintainanceSuccess(res),
      error=>this.checkMaintainanceFailure(error)
    )
  }
  checkMaintainanceSuccess(res){
    
    if(res.Status == 1){
      this.maintainanceActivity = JSON.parse(res.Data);
      if(JSON.parse(res.Data)[0]['MaintainanceActivity']== '0' 
      && JSON.parse(res.Data)[0]['ShowMaintenanceMessage']== '0'){
        this.dialogRef.close();
      }
    }

  }
  checkMaintainanceFailure(error){

  }
  closeMaintainance(){
    if(this.maintainanceActivity[0]['MaintainanceActivity'] == '0'){
      this.dialogRef.close();
    }
  }

}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/maintainance/maintainance.component.ts